export const styles = (theme) => ({
  root: {
    zIndex: 999,
    paddingTop: theme.spacing(6),
    position: 'relative',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(3),
    },
  },

  greyCurves: {
    width: '70%',
    position: 'absolute',
    right: 0,
    bottom: 0,
    zIndex: -1,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  bemAquiLogo: {
    zIndex: 999,
    height: 100,
    position: 'relative',
    marginBottom: theme.spacing(2),
  },

  title: {
    marginTop: theme.spacing(1),
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    zIndex: 999,
    fontFamily: 'Raleway',
    // textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },

  description: {
    color: theme.palette.text.primary,
    fontWeight: 400,
    zIndex: 999,
    fontWeight: 800,
    fontFamily: 'Poppins',
    margin: theme.spacing(3, 0, 2, 0),
    // textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },

  secondDescription: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    zIndex: 999,
    fontFamily: 'Poppins',
    fontSize: 12,
    // textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },

  formButton: {
    borderRadius: 50,
    fontWeight: 'bold',
    fontFamily: 'Poppins',
    width: '100%',
    boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.15)',
    margin: theme.spacing(3, 0),
    height: theme.spacing(6),
    [theme.breakpoints.up('sm')]: {
      maxWidth: 300,
    },
    [theme.breakpoints.down('xs')]: {
      height: theme.spacing(8),
    },
  },

  indicar: {
    color: '#fff',
    backgroundColor: theme.palette.secondary.main,
    // '&:hover': {
    //   backgroundColor: theme.palette.secondary.light,
    // },
  },

  cadastrar: {
    border: `3px solid ${theme.palette.secondary.main}`,
  },

  formButtonLabel: {
    fontSize: '0.8rem',
  },

  headerIcon: {
    width: '100%',
    zIndex: 999,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
})
